/**
 * 重置密码弹框 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { Modal, Input, Form, message } from 'antd';
import styles from './ResetPassword.module.scss';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
    },
};

class ResetPassword extends React.Component {
    formRef = React.createRef();
    state = {
        confirmLoading: false,
    }

    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { id } = this.props;
            const { password } = fieldsValue;
            this.setState({ confirmLoading: true });
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.resetEmplPwd', { id, newPwd: password }, 'POST').then(() => {
                message.success('修改成功！');
                this.setState({ confirmLoading: false });
                this.props.closeModal(true);
            }).catch((e) => {
                message.error(e.message);
                this.setState({ confirmLoading: false });
            });
        });
    }

    // 点击取消
    _handleCancel = () => {
        this.props.closeModal();
    }

    compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== this.formRef.current.getFieldValue('password')) {
            callback('两次输入的密码不一致!');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        if (value && this.state.confirmDirty) {
            this.formRef.current.validateFields(['confirm'], { force: true });
        }
        callback();
    };

    render() {
        const { confirmLoading } = this.state;
        return (
            <Modal
                width={600}
                centered
                title='修改密码'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        style={{ margin: '0 20px' }}
                        {...formItemLayout}
                        ref={this.formRef}
                        initialValues={{}}
                        scrollToFirstError
                    >
                        <Form.Item
                            label="新密码"
                            name="password"
                            rules={[
                                { required: true },
                                { min: 6, max: 16, message: '密码安全性不高，请输入6～16位密码' },
                                { validator: this.validateToNextPassword }
                            ]}>
                            <Input.Password placeholder='请输入密码' />
                        </Form.Item>
                        <Form.Item
                            label="确认新密码"
                            name="confirm"
                            rules={[
                                { required: true, message: '请输入确认密码' },
                                { min: 6, max: 16, message: '密码安全性不高，请输入6～16位密码' },
                                { validator: this.compareToFirstPassword }
                            ]}>
                            <Input.Password placeholder='请再次输入密码' />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

ResetPassword.propTypes = {
    id: PropTypes.number, // 弹框入参
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default ResetPassword;